import React from 'react';
import { FadeIn } from './FadeIn';
import { ButtonCTA } from './ButtonCTA';
import { BookOpen, List, Map, PartyPopper, Sparkles } from 'lucide-react';
export function Package() {
  const includes = [{
    icon: <BookOpen size={24} data-id="element-122" />,
    text: 'Manual premium completo'
  }, {
    icon: <List size={24} data-id="element-123" />,
    text: '32 recetas sencillas'
  }, {
    icon: <Map size={24} data-id="element-124" />,
    text: 'Guía para comer fuera'
  }, {
    icon: <PartyPopper size={24} data-id="element-125" />,
    text: 'Capítulo de fiestas y alcohol'
  }, {
    icon: <Sparkles size={24} data-id="element-126" />,
    text: 'Sistema de sustitución inteligente'
  }];
  return <section className="py-20 bg-warm-beige/50" data-id="element-127">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-128">
        <FadeIn data-id="element-129">
          <div className="text-center mb-12" data-id="element-130">
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-warm-brown mb-6" data-id="element-131">
              Qué Incluye
            </h2>
          </div>
        </FadeIn>

        <div className="bg-white rounded-3xl shadow-lg overflow-hidden border border-warm-beige" data-id="element-132">
          <div className="p-8 md:p-12" data-id="element-133">
            <div className="space-y-6 mb-12" data-id="element-134">
              {includes.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-135">
                  <div className="flex items-center p-4 rounded-xl hover:bg-warm-beige/30 transition-colors" data-id="element-136">
                    <div className="bg-olive-green/10 text-olive-green p-3 rounded-full mr-6" data-id="element-137">
                      {item.icon}
                    </div>
                    <span className="text-lg md:text-xl font-medium text-gray-800" data-id="element-138">
                      {item.text}
                    </span>
                  </div>
                </FadeIn>)}
            </div>

            <FadeIn delay={0.5} data-id="element-139">
              
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}